import { useMutation, useQueryClient } from '@tanstack/react-query';
import { APIClinic } from 'lib/api/firebase/apis/api-clinic-balance';
import { useState } from 'react';

export type OperationStatus = {
  clinicId: string;
  type: 'join' | 'leave';
  status: 'success' | 'error' | null;
};

export function useOrganisationMutations(currentUserUid: string | undefined, errorList: any) {
  const queryClient = useQueryClient();
  const [operationStatus, setOperationStatus] = useState<OperationStatus | null>(null);

  const joinMutation = useMutation({
    mutationFn: (clinicId: string) => APIClinic.joinGlobalAdmin({ clinicId }),
    onSuccess: (_, clinicId) => {
      setOperationStatus({ clinicId, type: 'join', status: 'success' });
      setTimeout(() => setOperationStatus(null), 3000);
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      if (currentUserUid) {
        queryClient.invalidateQueries({ queryKey: ['clinician', 'data', currentUserUid] });
      }
    },
    onError: (error, clinicId) => {
      setOperationStatus({ clinicId, type: 'join', status: 'error' });
      setTimeout(() => setOperationStatus(null), 3000);
      errorList.addError(error as Error, 'joinGlobalAdmin');
    }
  });

  const leaveMutation = useMutation({
    mutationFn: (clinicId: string) => APIClinic.leaveGlobalAdmin({ clinicId }),
    onSuccess: (_, clinicId) => {
      setOperationStatus({ clinicId, type: 'leave', status: 'success' });
      setTimeout(() => setOperationStatus(null), 3000);
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      if (currentUserUid) {
        queryClient.invalidateQueries({ queryKey: ['clinician', 'data', currentUserUid] });
      }
    },
    onError: (error, clinicId) => {
      setOperationStatus({ clinicId, type: 'leave', status: 'error' });
      setTimeout(() => setOperationStatus(null), 3000);
      errorList.addError(error as Error, 'leaveGlobalAdmin');
    }
  });

  return {
    joinMutation,
    leaveMutation,
    operationStatus
  };
}
